var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, action, makeObservable } from 'mobx';
import log from 'loglevel';
import { RemoteDataStore } from '../RemoteDataStore';
export class FlightStore extends RemoteDataStore {
    constructor(api) {
        super();
        Object.defineProperty(this, "flights", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "api", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadedFrom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadedTo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            handleResponse: action,
            clear: action,
        });
        this.api = api;
    }
    loadBetween(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const scheduledTimestamp = `${Math.floor(from)}..${Math.floor(to)}`;
            const params = {
                scheduledTimestamp,
            };
            yield this.load(params);
            this.loadedFrom = from;
            this.loadedTo = to;
        });
    }
    performRequest(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug('Load flights', params);
            return this.api.flights().get(params, options);
        });
    }
    handleResponse(response) {
        const flights = response.data.flights || [];
        log.debug('Flights loaded', flights);
        this.flights.replace(flights);
    }
    clear() {
        this.loadedFrom = undefined;
        this.loadedTo = undefined;
        this.flights.clear();
    }
}
//# sourceMappingURL=FlightStore.js.map